<ui-grid [data]="data$ | async"
         [loading]="loading$ | async"
         class="ui-jobs-page-grid">
    <ui-grid-header [search]="true">
        <ui-header-button type="inline">
            <ng-template>
                <ui-grid-reset *ngIf="hasCustomFilters$ | async"
                               (reset)="resetFilter()"></ui-grid-reset>
            </ng-template>
        </ui-header-button>
        <ui-header-button type="main">
            <ng-template>
                <button *ngIf="isCurrentFolderClassic$ | async"
                        [uiAuthorizeAllDisable]="['Jobs.Create', 'Processes.View', 'Robots.View']"
                        [matTooltip]="'jobs_grid_action_start' | translate"
                        [disableIf]="isLicenseInvalid$ | async"
                        [uiClickTrack]="'Action: Add Job'"
                        (click)="openModal()"
                        color="primary"
                        mat-mini-fab
                        type="button">
                    <mat-icon>play_arrow</mat-icon>
                </button>
            </ng-template>
        </ui-header-button>
        <ui-header-button type="action">
            <ng-template>
                <button [uiAuthorizeDisable]="'Jobs.Edit'"
                        [disableIf]="!this.allowCancel"
                        [matTooltip]="'jobs_grid_action_stop' | translate"
                        (click)="stopJob(false)"
                        mat-icon-button
                        type="button">
                    <mat-icon svgIcon="uipath:JobCancel20px"></mat-icon>
                </button>
            </ng-template>
        </ui-header-button>
        <ui-header-button type="action">
            <ng-template>
                <button [uiAuthorizeDisable]="'Jobs.Edit'"
                        [matTooltip]="'jobs_grid_action_kill' | translate"
                        [disableIf]="!this.allowTerminate"
                        (click)="stopJob(true)"
                        mat-icon-button
                        type="button">
                    <mat-icon svgIcon="uipath:JobTerminate20px"></mat-icon>
                </button>
            </ng-template>
        </ui-header-button>
    </ui-grid-header>
    <ui-grid-column [sortable]="true"
                    [searchable]="true"
                    [primary]="true"
                    [title]="'jobs_grid_process' | translate"
                    property="release.processKey"
                    width="15%">
    </ui-grid-column>
    <ui-grid-column [sortable]="true"
                    [searchable]="true"
                    [title]="'jobs_grid_robot' | translate"
                    property="robot.name"
                    width="15%">
        <ng-template let-entry="data">
            <ng-container *ngLet="(
                              entry.robot ?
                                entry.robot.name :
                                ('jobs_grid_pending_robot_allocation' | translate)
                           ) as robot ">
                <span [matTooltip]="robot">
                    {{ robot }}
                </span>
            </ng-container>
        </ng-template>
    </ui-grid-column>
    <ui-grid-column *ngIf="isCurrentFolderClassic$ | async"
                    [sortable]="false"
                    [searchable]="true"
                    [title]="'jobs_grid_environment' | translate"
                    property="environmentName"
                    width="15%">
    </ui-grid-column>
    <ui-grid-column [primary]="true"
                    [sortable]="true"
                    [title]="'jobs_grid_state' | translate"
                    property="state"
                    width="15%">
        <ng-template let-entry="data">
            <ng-container [ngSwitch]="JobState[entry.state]">
                <mat-icon *ngSwitchCase="JobState.Pending"
                          svgIcon="uipath:StatusElipses">
                </mat-icon>
                <mat-icon *ngSwitchCase="JobState.Running"
                          svgIcon="uipath:StatusPlay"
                          color="primary">
                </mat-icon>
                <mat-icon *ngSwitchCase="JobState.Stopping"
                          svgIcon="uipath:StatusPlay"
                          color="primary">
                </mat-icon>
                <mat-icon *ngSwitchCase="JobState.Terminating"
                          svgIcon="uipath:StatusPlay"
                          color="primary">
                </mat-icon>
                <mat-icon *ngSwitchCase="JobState.Stopped"
                          svgIcon="uipath:StatusCanceling">
                </mat-icon>
                <mat-icon *ngSwitchCase="JobState.Successful"
                          svgIcon="uipath:StatusOK"
                          color="success">
                </mat-icon>
                <mat-icon *ngSwitchCase="JobState.Suspended">hourglass_empty</mat-icon>
                <mat-icon *ngSwitchCase="JobState.Resumed"
                          svgIcon="uipath:StatusElipses">
                </mat-icon>
                <mat-icon *ngSwitchDefault
                          svgIcon="uipath:StatusWarning">
                </mat-icon>
            </ng-container>
            <ng-container *ngLet="('JobState_' + entry.state | translate) as state">
                <span [matTooltip]="state">
                    {{state}}
                </span>
            </ng-container>
        </ng-template>
        <ui-grid-dropdown-filter [items]="stateList">
        </ui-grid-dropdown-filter>
    </ui-grid-column>
    <ui-grid-column [title]="'jobs_grid_started' | translate"
                    [sortable]="true"
                    property="startTime"
                    width="15%">
        <ng-template let-index="index"
                     let-entry="data">
            <ui-dateformat #startDateFormat
                           [matTooltip]="startDateFormat?.dataset['title']"
                           [date]="entry.startTime"
                           contentType="relative"></ui-dateformat>
        </ng-template>
    </ui-grid-column>
    <ui-grid-column [title]="'jobs_grid_ended' | translate"
                    [sortable]="true"
                    property="endTime"
                    width="15%">
        <ng-template let-index="index"
                     let-entry="data">
            <ui-dateformat #endDateFormat
                           [matTooltip]="endDateFormat?.dataset['title']"
                           [date]="entry.endTime"
                           contentType="relative"></ui-dateformat>
        </ng-template>
    </ui-grid-column>
    <ui-grid-column [title]="'jobs_grid_source' | translate"
                    [sortable]="true"
                    property="sourceType"
                    width="10%">
        <ui-grid-dropdown-filter [items]="sourceList">
        </ui-grid-dropdown-filter>
        <ng-template let-entry="data">
            <span *ngIf="[JobSource.Schedule, JobSource.Queue]
                            .includes(JobSource[entry.sourceType]);
                        else sourceType"
                  [matTooltip]="entry.source">
                {{ entry.source }}
            </span>
            <ng-template #sourceType>
                <ng-container *ngLet="('JobSource_' + entry.sourceType | translate) as sourceType ">
                    <span [matTooltip]="sourceType">
                        {{ sourceType }}
                    </span>
                </ng-container>
            </ng-template>
        </ng-template>
    </ui-grid-column>
    <ui-grid-column [visible]="false"
                    [title]="'grid_column_filter_interval' | translate"
                    property="creationTime"
                    sort="desc">
        <ui-grid-dropdown-filter [items]="intervals"
                                 [value]="intervalValueFor(Interval.Day)"
                                 method="ge">
        </ui-grid-dropdown-filter>
    </ui-grid-column>
    <ui-grid-row-action>
        <ng-template let-index="index"
                     let-entry="data">
            <button [uiAuthorizeAnyDisable]="['Logs.View', 'Jobs.Edit']"
                    [matTooltip]="'global_more_actions_tooltip' | translate"
                    [matMenuTriggerFor]="menu"
                    data-cy="grid-action-menu"
                    mat-icon-button
                    type="button">
                <mat-icon svgIcon="uipath:More"></mat-icon>
            </button>
            <mat-menu #menu="matMenu">
                <button [disabled]="disableDetails$ | async"
                        [uiClickTrack]="'Action: Grid: View Details'"
                        (click)="showDetails(entry)"
                        mat-menu-item
                        type="button">
                    <mat-icon svgIcon="uipath:info"></mat-icon>
                    {{'jobs_grid_action_details' | translate}}
                </button>
                <a [routerLink]="['/jobs', entry.id, 'logs']"
                   [uiAuthorizeDisable]="'Logs.View'"
                   mat-menu-item>
                    <mat-icon>notes</mat-icon>
                    {{ 'jobs_grid_action_view_logs' | translate }}
                </a>
                <!--
                    using *ngIf affects order for keyboard nav [a11y]
                    TODO: remove if fix is merged
                    https://github.com/angular/material2/pull/11720
                -->
                <button [hidden]="!isMediaRecordingEnabled ||
                               !entry.hasMediaRecorded"
                        [disableIf]="!isMediaRecordingEnabled ||
                               !entry.hasMediaRecorded"
                        [uiAuthorize]="'ExecutionMedia.View'"
                        [uiClickTrack]="'Action: Grid: Download Recording'"
                        (click)="downloadRecording(entry)"
                        mat-menu-item
                        type="button">
                    <mat-icon>video_library</mat-icon>
                    {{ 'jobs_grid_action_download_recording' | translate }}
                </button>
                <button [disableIf]="!isCancellingAllowed(entry)"
                        [uiAuthorizeDisable]="'Jobs.Edit'"
                        [uiClickTrack]="'Action: Grid: Stop'"
                        (click)="stopJob(false, entry)"
                        mat-menu-item
                        data-cy="job-stop"
                        type="button">
                    <mat-icon svgIcon="uipath:JobCancel"></mat-icon>
                    {{ 'jobs_grid_action_stop' | translate }}
                </button>
                <button [disableIf]="!isTerminationAllowed(entry)"
                        [uiAuthorizeDisable]="'Jobs.Edit'"
                        [uiClickTrack]="'Action: Grid: Kill'"
                        (click)="stopJob(true, entry)"
                        mat-menu-item
                        data-cy="job-kill"
                        type="button">
                    <mat-icon svgIcon="uipath:JobTerminate"></mat-icon>
                    {{ 'jobs_grid_action_kill' | translate }}
                </button>
                <button [disableIf]="!isResumeAllowed(entry)"
                        [uiAuthorizeDisable]="'Jobs.Edit'"
                        [uiClickTrack]="'Action: Grid: Resume'"
                        (click)="resumeJob(entry)"
                        mat-menu-item
                        data-cy="job-resume"
                        type="button">
                    <mat-icon>play_circle_outline</mat-icon>
                    {{ 'jobs_grid_action_resume' | translate }}
                </button>
                <button [hidden]="!isManualRestartFeatureEnabled"
                        [disableIf]="!isRestartAllowed(entry)"
                        [uiAuthorizeDisable]="'Jobs.Create'"
                        [uiClickTrack]="'Action: Grid: Restart'"
                        (click)="openModal(entry)"
                        mat-menu-item
                        data-cy="job-restart"
                        type="button">
                    <mat-icon>loop</mat-icon>
                    {{ 'jobs_grid_action_restart' | translate }}
                </button>
            </mat-menu>
        </ng-template>
    </ui-grid-row-action>
    <ui-grid-footer [length]="total$ | async"
                    [pageSize]="pageSize"
                    [pageSizes]="pageSizes">
    </ui-grid-footer>
</ui-grid>
